// catalog-pending stub for C53-STATUS-BADGE-13-ESTADOS unit contract.
// Once the product ships the real status-badge color map, replace this stub
// and adjust the unit test to import from the canonical module. Until then,
// the stub throws so the spec fails loud against the oracle.

export type StatusKey =
  | "matrix-webhook-processed"
  | "matrix-webhook-delivered"
  | "matrix-webhook-failed"
  | "matrix-webhook-dead"
  | "matrix-webhook-ignored"
  | "matrix-webhook-pending"
  | "wallet-win"
  | "wallet-loss"
  | "wallet-pending"
  | "wallet-cancelled"
  | "subscription-active"
  | "subscription-grace"
  | "subscription-pending"
  | "subscription-expired"
  | "subscription-canceled"
  | "tokens-consume"
  | "tokens-topup"
  | "tokens-manual";

const BADGE_CLASS_BY_STATUS: Partial<Record<StatusKey, string>> = {
  "matrix-webhook-processed": "bg-success/10 text-success",
  "matrix-webhook-failed": "bg-loss/15 text-loss",
  "matrix-webhook-ignored": "bg-muted text-muted-foreground",
  "matrix-webhook-pending": "bg-warning/10 text-warning",
  "wallet-win": "bg-win/10 text-win",
  "wallet-loss": "bg-loss/10 text-loss",
  "wallet-pending": "bg-warning/10 text-warning",
  "subscription-active": "bg-success/10 text-success",
  "subscription-grace": "bg-warning/10 text-warning",
  "subscription-pending": "bg-warning/10 text-warning",
  "subscription-expired": "bg-loss/15 text-loss",
  "subscription-canceled": "bg-loss/15 text-loss",
  "tokens-consume": "bg-loss/15 text-loss",
  "tokens-topup": "bg-success text-primary-foreground",
};

export function badgeClass(status: StatusKey): string {
  const className = BADGE_CLASS_BY_STATUS[status];
  if (className) return className;
  throw new Error(
    `Unknown status badge key: ${status}; expected one of C53-STATUS-BADGE-13-ESTADOS`,
  );
}
